var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPyth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#110F24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.714 11.143c0 .827-.711 1.286-1.285 1.286v1.714a3 3 0 1 0-3-3v7.372l1.714 1.628v-9c0-.557.459-1.286 1.286-1.286a1.286 1.286 0 0 1 1.285 1.286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.429 5.143a5.97 5.97 0 0 0-4.5 2.032a5.98 5.98 0 0 0-1.5 3.968v4.5l1.714 1.65v-6.15c0-2.237 1.8-4.286 4.286-4.286s4.285 2.07 4.285 4.286c0 2.486-2.048 4.286-4.285 4.286v1.714a6 6 0 0 0 0-12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyth);
export default __webpack_public_path__ + "static/media/pyth.e81cf44f27dc82145e8c1ac94ad531ee.svg";
export { ForwardRef as ReactComponent };